import i18n from '@/plugins/vue-i18n';
import type { RouteRecordRaw } from 'vue-router';
import { isInternalViewsEnabled } from '@/utils/flags';

const { t } = i18n.global;

const InternalRoutes: Array<RouteRecordRaw> = isInternalViewsEnabled
  ? [
      {
        path: '/design-system',
        name: 'design-system',
        component: () => import('@/assets/DesignSystem.vue'),
        meta: {
          title: t('pageTitles.designSystem'),
          layout: 'navigationOnly',
          requiresAuth: true,
          unguarded: 'Internal developer view, non-production builds only',
        },
      },
      {
        path: '/permissions-matrix',
        name: 'permissions-matrix',
        component: () => import('@/views/internal/PermissionsMatrixView.vue'),
        meta: {
          title: t('pageTitles.permissionsMatrix'),
          layout: 'navigationOnly',
          requiresAuth: true,
          unguarded: 'Internal developer view, non-production builds only',
        },
      },
    ]
  : [];

export default InternalRoutes;
